var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.top",value:(_vm.tagDesc),expression:"tagDesc",modifiers:{"hover":true,"top":true}}],style:(`background-color: ${_vm.rgba}; background-opacity: 0.12; color: ${_vm.color};`),attrs:{"pill":""}},[_vm._v(_vm._s(_vm.tagName))])
}
var staticRenderFns = []

export { render, staticRenderFns }